@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-row items-center w-full">
      @if (field.browserOpts.inLineWithCaption) {
        <mat-label class="mr-2 mb-4 font-medium">
          {{ field.label | localize }}
        </mat-label>
      }
      <div>
        @if (!field.browserOpts.inLineWithCaption) {
          <mat-label>{{ field.label | localize }}</mat-label>
        }
        <div class="flex items-center pt-2">
          @for (view of views; track view; let i = $index) {
            <button class="mx-2" mat-icon-button (click)="markRating(i)" [disabled]="field.readonly || field.control.disabled">
              <mat-icon class="text-blue-400 scale-[2]" [svgIcon]="!view ? 'heroicons_outline:star' : 'heroicons_solid:star'"></mat-icon>
            </button>
          }
          @if (!field.readonly && !field.control.disabled) {
            <button class="ml-2" mat-raised-button (click)="createAC()">
              Añadir acción correctiva
              <mat-icon [svgIcon]="'mat_outline:add'"></mat-icon>
            </button>
          }
        </div>
        @if (field.hint) {
          <mat-hint>{{ field.hint | localize }}</mat-hint>
        }
        @if (field.control.hasError('required') && !field.readonly && touched || field.control.value === 0) {
          <mat-error>
            {{ 'errorRequiredField' | transloco }}
          </mat-error>
        }
        @if (field.control.hasError('max') && !field.readonly) {
          <mat-error>
            {{ 'errorMaxValueField' | transloco:{ max: field.control.errors.max.max } }}
          </mat-error>
        }
      </div>
    </div>
  }
} @else {
  @for (view of views; track view; let i = $index) {
    @if (view) {
      <mat-icon [svgIcon]="'heroicons_solid:star'"></mat-icon>
    }
  }
}
